// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/role_action_mapping",
    element: lazy(() =>
      import("../../pages/UserAccess/RoleActionMapping/index")
    ),
  },
  {
    path: "/role_action_mapping/add",
    element: lazy(() =>
      import("../../pages/UserAccess/RoleActionMapping/create")
    ),
  },
  {
    path: "/role_action_mapping/edit/:id",
    element: lazy(() =>
      import("../../pages/UserAccess/RoleActionMapping/edit")
    ),
  },
];

export default routes;
